import Header from '../Header'
import Footer from '../Footer'



import './ourclients.sass'

const OurClients = () => {
    
    return (

        <main className='ourclients'>

            <Header />   
            <div className='container'>
                <h1 className='title'>
                   About Public Sector Excellence </h1>
                <p>Public Sector Excellence is an organizational development and training firm founded in 1995 that specializes in helping Public Sector leaders, managers, supervisors and employees build excellence in their organizations and in the services they provide.  To help address the unique opportunities and constraints that public sector organizations face, the firm employs consultants and trainers who understand the public sector and have experience working with city, county, state and federal government, school districts, courts, educational institutions, boards, commissions, joint powers and other public organizations.</p>


                <h3 className='title title--sub'>
                   Government Client Experience </h3>
                <h5 className='title title--sm'>
                    Public Sector Excellence client and workshop participant organizations have included:
                </h5>

                <div className='grid grid--col2 grid--space'>
                    <div className='grid__col'>
                        <ul className='list'>
                            <li>City of Palo Alto</li>
                            <li>City of Santa Clara</li>
                            <li>California Joint Powers Insurance Authority</li>
                            <li>Sanitation Districts of Orange County</li>
                            <li>County of Los Angeles Social Services</li>
                            <li>City of Concord</li>
                            <li>City of Ventura</li>
                            <li>City of Farmersville</li>
                            <li>The State Bar of California</li>
                            <li>Santa Monica Big Blue Bus</li>
                            <li>California Assoc. of School Business Officials</li>
                            <li>City of Manhattan Beach</li>
                            <li>City of Huntington Beach</li>
                            <li>County of Orange</li>
                            <li>County of Los Angeles Internal Services</li>
                            <li>City of Thousand Oaks</li>
                            <li>California Association /Tax Collectors/Treasurers</li>
                            <li>California Assoc. of County Clerks and Recorders</li>
                            <li>California Assessors (CAASA)</li>
                            <li>Family and Children Together (FACT)</li>
                            <li>City of Solvang</li>
                            <li>Port of Oakland</li>
                            <li>Ukiah Unified School District</li>
                            <li>United States Navy</li>
                            <li>City of Modesto</li>
                            <li>Asian Pacific American Institute for Congressional Studies</li>
                        </ul>
                    </div>
                    <div className='grid__col'>
                        <ul className='list'>
                            <li>City of Lakewood</li>
                            <li>City of Long Beach</li>
                            <li>City of Oxnard    </li>
                            <li>City of Menlo Park</li>
                            <li>County of Mendocino</li>
                            <li>Internal Revenue Service</li>
                            <li>County of Napa</li>
                            <li>California Judicial Council</li>
                            <li>City of Galt</li>
                            <li>County of Sonoma	</li>
                            <li>County of Kern</li>
                            <li>City of Fresno</li>
                            <li>City of Beverly Hills</li>
                            <li>City of Monterey</li>
                            <li>The Cambodian Family</li>
                            <li>City of Stockton</li>
                            <li>City of Whittier</li>
                            <li>City of Chino</li>
                            <li>Newport-Mesa Unified School District</li>
                            <li>City of Santa Monica</li> 
                            <li>Berkeley Unified School District</li>
                            <li>City of Oakland</li>
                            <li>County of Orange Superior Court</li>
                            <li>Los Angeles Unified School District</li>
                            <li>County of San Luis Obispo EOC</li>
                        </ul>
                    </div>
                </div>

               



            </div>         
            <Footer />
        </main>

    )
}

export default OurClients